import { createAuthClient } from 'better-auth/react'
import { config } from './config/config'

const authClient = createAuthClient({
  baseURL: config.apiEndpoint,
})

const useSession = authClient.useSession

const useCurrentUser = function () {
  const session = useSession()

  if (!session.data?.user) {
    throw new Error('No user in session')
  }

  return session.data.user
}

export { useSession, authClient, useCurrentUser }
